import { FILTERS_TAB_KEY } from "@/constants";
import { IPanelScope } from "@/interfaces";
import { FiltersService, FoldersService } from "@/services";

export const redirect = (url: string) => (location.href = url);

export const getActiveItemFromUrl = (scope: IPanelScope): string | null => {
  if (scope.tab === FILTERS_TAB_KEY) {
    return FiltersService.getActiveFilterIdFromUrl();
  } else {
    return FoldersService.getActiveFolderFromUrl();
  }
};
